import Marionette from "backbone.marionette";
import Components from "../../utils/components";

const DEFAULTS = {};

const FORM_CONFIG = [
  {
    element: "input",
    required: true,
    type: "text",
    requestParameterName: "firstName",
    description: "First Name",
  },
  {
    element: "input",
    required: true,
    type: "text",
    requestParameterName: "lastName",
    description: "Last Name",
  },
  {
    element: "input",
    type: "telephone",
    requestParameterName: "phone",
    description: "Phone Number",
    regex: "\\d{3}[-]\\d{3}[-]\\d{4}",
    placeholder: "Format: 212-555-1234",
  },
];

class FormBody extends Marionette.ItemView {
  constructor(options = {}) {
    _.defaults(options, DEFAULTS);
    super(options);
  }

  ui() {
    return {
      firstName: "#firstName",
      lastName: "#lastName",
      phone: "#phone",
    };
  }

  events() {
    return {
      "change @ui.firstName": "_handleText",
      "change @ui.lastName": "_handleText",
      "change @ui.phone": "_handleText",
    };
  }

  onBeforeRender() {
    // get current values model
    const data = this.model.get("data");

    // augment form config with values from model
    _.each(FORM_CONFIG, (field) => {
      field.currentSelection = data.get(field.requestParameterName) || "";
      field.elementId = field.requestParameterName;
    });

    // generate components
    const content = Components.generate(FORM_CONFIG);

    // set our template
    this.template = _.template(content);
  }

  _handleText(e) {
    const $el = $(e.target);
    const text = $el.val().trim();

    // update property on model
    this.model.getData().set($el[0].id, !_.isEmpty(text) ? text : null);
  }
}

export { FormBody as default };
